<template lang="pug">
v-navigation-drawer(
  v-model="showDrawer" 
  width="375" 
  temporary 
  right 
  hide-overlay
  app
  bottom
)
  .mt-16
    KeepAlive(include="main")
      .pa-6(v-if="page === 'main'")
        .d-flex.align-end
          .h5 {{ $t('add_filter') }}
          v-spacer
          .link-s(@click="clearFilters") {{ $t('clear_all_filters') }}
        .mt-8
          div(v-for="item in items")
            div.mb-4(v-if="getChanges(item.type).length")
              .d-flex.align-center
                .flex-grow-1
                  .text-md.font-medium Filter {{ item.name }}
                  .text-sm.font-normal.primary400--text(v-for="(changes, index) in getChanges(item.type)" :key="index") {{ changes }}
                v-btn(@click="openDetail(item.type)" color="primary400" icon)
                  v-icon(small) $yzi-edit-02
              v-divider.mt-4
          div(v-for="item in items")
            v-btn.py-6.mb-3.round-xl(
              v-if="!getChanges(item.type).length"
              @click="openDetail(item.type)"
              :key="item.type" 
              outlined 
              color="#ddd" 
              block
            )
              .text-md.font-medium.text-none.neutral700--text Filter {{ item.name }}
              v-spacer
              eva-icon.d-flex(name="arrow-ios-forward" fill="#888")
        .py-12
        .yc-fixed-bottom-section
          v-btn.button-Aa-medium.white--text(@click="clickDone" color="info500" x-large block depressed height="40") {{ $t('done') }}
      filter-segment(
        v-else-if="page === 'segment'"
        :filter.sync="segmentFilter"
        @onBack="back" 
      )
      filter-alphanumeric(
        v-else-if="page === 'name'" 
        type="name"
        :filter.sync="nameFilter"
        @onBack="back" 
      )
      filter-alphanumeric(
        v-else-if="page === 'nickname'"
        type="nickname"
        :filter.sync="nicknameFilter"
        @onBack="back" 
      )
      filter-alphanumeric(
        v-else-if="page === 'email'"
        type="email"
        :filter.sync="emailFilter"
        @onBack="back" 
      )
      filter-alphanumeric(
        v-else-if="page === 'phone'"
        type="phone"
        :filter.sync="phoneFilter"
        @onBack="back" 
      )
      filter-gender(
        v-else-if="page === 'gender'"
        :filter.sync="genderFilter"
        @onBack="back" 
      )
      filter-date(
        v-else-if="page === 'created'"
        :filter.sync="dateFilter"
        @onBack="back" 
      )
      filter-age(
        v-else-if="page === 'age'"
        :filter.sync="ageFilter"
        @onBack="back" 
      )
      filter-total-contribution(
        v-else-if="page === 'total_paid'"
        :filter.sync="countFilter"
        @onBack="back" 
      )
</template>

<script>
import FilterSegment from '@/components/connect/FilterSegment.vue'
import FilterAlphanumeric from '@/components/connect/FilterAlphanumeric.vue'
import FilterGender from '@/components/connect/FilterGender.vue'
import FilterDate from '@/components/connect/FilterDate.vue'
import FilterAge from '@/components/connect/FilterAge.vue'
import FilterTotalContribution from '@/components/donation/FilterTotalContribution.vue'

export default {
  props: ['open', 'filterData'],
  components: {
    FilterSegment,
    FilterAlphanumeric,
    FilterGender,
    FilterDate,
    FilterAge,
    FilterTotalContribution
  },
  data: () => ({
    page: 'main',
    segmentFilter: {},
    nameFilter: {},
    nicknameFilter: {},
    emailFilter: {},
    phoneFilter: {},
    genderFilter: {},
    dateFilter: {},
    ageFilter: {},
    countFilter: {},
    items: [
      
      {
        name: 'name',
        type: 'name'
      },
      {
        name: 'phone number',
        type: 'phone'
      },
      {
        name: 'email',
        type: 'email'
      },
      {
        name: 'contribution',
        type: 'total_paid'
      },
      {
        name: 'segment',
        type: 'segment'
      }
    ]
  }),
  computed: {
    showDrawer: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    clearFilters() {
      this.segmentFilter = {}
      this.nameFilter = {}
      this.nicknameFilter = {}
      this.emailFilter = {}
      this.phoneFilter = {}
      this.genderFilter = {}
      this.dateFilter  = {}
      this.ageFilter = {}
      this.countFilter = {}
    },
    clickDone() {
      const filters = {
        name: this.nameFilter.exact,
        name__contains: this.nameFilter.all,
        name__exclude: this.nameFilter.none,
        nickname: this.nicknameFilter.exact,
        nickname__contains: this.nicknameFilter.all,
        nickname__exclude: this.nicknameFilter.none,
        email: this.emailFilter.exact,
        email__contains: this.emailFilter.all,
        email__exclude: this.emailFilter.none,
        phone: this.phoneFilter.exact,
        phone__exclude: this.phoneFilter.none,
        gender: this.genderFilter.gender,
        created__before: this.dateFilter.before,
        created__after: this.dateFilter.after,
        created__on: this.dateFilter.on,
        groups: this.segmentFilter.segments?.join(','),
        total_paid: this.countFilter.equal,
        total_paid__gte: this.countFilter.more,
        total_paid__lte: this.countFilter.less,
        age: this.ageFilter.equal,
        age__gt: this.ageFilter.more,
        age__lt: this.ageFilter.less
      }
      this.$store.commit('customers/setFilters', filters)
      this.showDrawer = false
    },
    openDetail(page) {
      this.page = page
    },
    back() {
      this.page = 'main'
    },
    getChanges(type) {
      let changes = []
      let obj = {}
      switch (type) {
        case 'name':
          obj = this.nameFilter
          break
        case 'nickname':
          obj = this.nicknameFilter
          break
        case 'email':
          obj = this.emailFilter
          break
        case 'phone':
          obj = this.phoneFilter
          break
        case 'gender':
          obj = this.genderFilter
          break
        case 'created':
          obj = this.dateFilter
          break
        case 'segment':
          obj = this.segmentFilter
          break
        case 'order_count':
          obj = this.countFilter
          break
        case 'age':
          obj = this.ageFilter
          break
      }
      for (const key in obj) {
        const val = obj[key]
        if (val) {
          if (key !== 'segments') {
            const name = this.getNameFromFilterKey(key, type)
            let description = val
            if (key === 'segment_titles') {
              description = val.join(', ')
            }
            if (key === 'gender')  {
              description = this.$options.filters.capitalize(val)
            }
            changes.push(`${name} ${description}`)
          }
        }
      }
      return changes
    },
    getNameFromFilterKey(key, type){
      switch(key) {
        case 'segment_titles':
          return 'Segment choosen:'
        case 'all':
          return 'All of these words:'
        case 'exact':
          return type === 'age' ? 'Exact age of ' :'Exact word:'
        case 'none':
          return 'None of these words:'
        case 'more':
          return type === 'age' ? 'Older than' : 'More than'
        case 'less':
          return type === 'age' ? 'Younger than' : 'Less than'
        case 'before':
          return 'Before'
        case 'after':
          return 'After'
        case 'gender':
          return 'Gender: '
      }
      return key
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), 
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  box-shadow: unset !important;
}
.v-navigation-drawer--temporary {
  z-index: unset;
}
.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
  max-height: 100% !important;
}
</style>